module.exports = __webpack_public_path__ + "static/2-5c14efafedc3611e8f45d6f6b7a247ee.jpg";